import { defineStore } from 'pinia';

import EpguApiService from '@/api/client/services/EpguApiService';

export const checkNotificationEpgu = defineStore('check-notification-epgu', {
  state: () => ({
    apiService: new EpguApiService(),
    epgu: {},
  }),
  actions: {
    async getEpgu() {
      const r = await this.apiService.getFilteredData(
        { include: 'req_state' },
        {}
      );

      if (!r.status) return;

      this.epgu.hasEpgu = Boolean(
        r.response?.data.find(item => item.req_state === 6)
      );
    },
    async init() {
      await this.getEpgu();

      this.epgu.timerId = setInterval(async () => {
        await this.getEpgu();
      }, 1200 * 1000);
    },
  },
});
